export function transformRowData(rowData: any, sortedTableHeaders: any[]) {
  return sortedTableHeaders.map((header: any) => {
    const key = header.key;
    let value = rowData[key] !== undefined ? rowData[key] : "";

    if (
      header.subKey &&
      value &&
      typeof value === "object" &&
      header.type === "string"
    ) {
      value = value[header.subKey] !== undefined ? value[header.subKey] : "";
    }

    return {
      value,
      type: header.type,
      width: header.width,
      header: key,
      rowData: rowData,
      fieldKey: key,
      originalRowData: rowData,
      actionHandlerName: header.actionHandlerName,
    };
  });
}
